import React, { useCallback } from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

export default function Footer() {
  const handleCookieSettings = useCallback((e) => {
    e.preventDefault();
    window.dispatchEvent(new Event("openCookieSettings"));
  }, []);

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>
          <Link to="/" className="site-footer__brand">
            Academy Costumes London
          </Link>
        </div>

        <nav aria-label="Footer navigation" className="site-footer__links">
          <Link to="/services">Services</Link>
          <Link to="/terms-and-conditions">Terms and Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/cookie-policy">Cookie Policy</Link>
          <button
            type="button"
            className="site-footer__cookie-btn"
            onClick={handleCookieSettings}
          >
            Cookie Settings
          </button>
        </nav>

        <small>© {new Date().getFullYear()} Academy Costumes London</small>
      </div>
    </footer>
  );
}
